"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _flag.default;
  }
});
var _webexCore = require("@webex/webex-core");
require("@webex/internal-plugin-conversation");
require("@webex/internal-plugin-device");
var _flag = _interopRequireDefault(require("./flag"));
var _config = _interopRequireDefault(require("./config"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerInternalPlugin)('flag', _flag.default, {
  config: _config.default,
  payloadTransformer: {
    predicates: [],
    transforms: []
  }
});
//# sourceMappingURL=index.js.map
